/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section2_Li2Inputs */

const en_privacy_section2_li2 = /** @type {(inputs: Privacy_Section2_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal information such as your name, email, or IP address`)
};

const ko_privacy_section2_li2 = /** @type {(inputs: Privacy_Section2_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이름, 이메일, IP 주소 등의 개인 정보`)
};

const ja_privacy_section2_li2 = /** @type {(inputs: Privacy_Section2_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`氏名、メールアドレス、IPアドレスなどの個人情報`)
};

/**
* | output |
* | --- |
* | "Personal information such as your name, email, or IP address" |
*
* @param {Privacy_Section2_Li2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const privacy_section2_li2 = /** @type {((inputs?: Privacy_Section2_Li2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section2_Li2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_section2_li2(inputs)
	if (locale === "ko") return ko_privacy_section2_li2(inputs)
	return ja_privacy_section2_li2(inputs)
});